import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Accountant as SectionKey } from 'Consts/Questionnaire';
import { section } from 'Consts/Queries';
import { QueryVal } from 'Helpers/Query';
import CircleWithCount from 'Icons/CircleWithCount';
import NumberInput from '../../../Fields/NumberInput';
import Section from '../../../Section';
import FieldList from '../../../Fields/FieldList';
import LabeledVerticalExpander from '../../../UI/LabeledVerticalExpander';
import TextInput from '../../../Fields/TextInput';

class OtherProfessionalsList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      accountantFirm: '',
    };

    this.onChange = this.onChange.bind(this);
  }

  onChange(name, value) {
    this.setState({ [name]: value });
  }

  render() {
    const { accountantFirm } = this.state;
    const {
      props: { id, children: removeButton, expanded },
    } = this;
    return (
      <LabeledVerticalExpander
        transitionSpeed={0.15}
        title={accountantFirm || 'New other professional'}
        removeButton={removeButton}
        firstElementFocusable
        expanded={expanded}
      >
        <TextInput
          placeholder="Firm"
          name={`accountantFirm.${id}`}
          answerKey="otherProfessionalFirm"
          onChange={(name, value) => this.onChange('accountantFirm', value)}
        />
        <TextInput
          placeholder="Name"
          name={`accountantName.${id}`}
          answerKey="otherProfessionalName"
        />
        <NumberInput
          placeholder="Length of relationship (years)"
          name={`accountantLengthOfRelationship.${id}`}
          answerKey="otherProfessionalLengthOfRelationship"
          decimalScale={0}
          min={0}
        />
      </LabeledVerticalExpander>
    );
  }
}

OtherProfessionalsList.propTypes = {
  id: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
  expanded: PropTypes.bool,
};

OtherProfessionalsList.defaultProps = {
  expanded: false,
};

const DefaultOtherProfessionals = () => {
  const [count, setCount] = React.useState(0);

  return (
    <Section
      expanded={QueryVal(section) === SectionKey}
      transitionSpeed={0.25}
      height={400}
      title="Other Professional"
      sectionKey={SectionKey}
      CountComponent={<CircleWithCount count={count} className="expander-header-count expander-header-left" />}
    >
      <FieldList
        onCountUpdate={setCount}
        addLabel="Add another professional"
        label="Other Professional"
        keyPrefix="otherProfessionals"
        Of={OtherProfessionalsList}
      />
    </Section>
  );
};

export default DefaultOtherProfessionals;
